import { FC } from "react";
import { useMe } from "@/data/user";
import { useBreakpoint } from "@/utils/hooks/useBreakpoints.ts";
import { useTranslation } from "react-i18next";
import { ProductLinks, Payment } from "@/types";
import dayjs from "dayjs";
import EyeIcon from "../icons/EyeIcon";
import ContractIcon from "../icons/ContractIcon";
import LoadingButton from "@edusogno/primitives/loading-button";

interface ContractProps {
  item: Payment;
}

const ContractItem: FC<ContractProps> = ({ item }) => {
  const { data, paid_for: paidFor, product } = item;

  const { t } = useTranslation();
  const { me } = useMe();
  const breakpoint = useBreakpoint();

  const terms = product?.terms_cond_locales
    ? (JSON.parse(
        product.terms_cond_locales as unknown as string,
      ) as ProductLinks)
    : { terms: {} };

  const lang = me?.item.user.lang
    ? me?.item.user.lang == "en"
      ? me?.item.user.lang_from_phone
        ? me?.item.user.lang_from_phone
        : me?.item.user.lang
      : me?.item.user.lang
    : "it";

  const links: { [key: string]: string } = terms?.terms;

  const isSmall = ["xs", "sm", "md"].indexOf(breakpoint) !== -1;

  return (
    links && (
      <div className="flex flex-row w-full items-center pl-4 gap-2 lg:gap-4 pr-6 py-3 bg-brand-light rounded-md">
        <ContractIcon className="fill-brand-secondary w-5 h-auto" />

        <div className="flex flex-col flex-grow">
          <p className="text-primary text-xs">
            {t("invoices.contract_accepted", {
              defaultValue: "Contract accepted on",
            })}
            :{" "}
            <b className="font-semibold">
              {dayjs(data)
                .format("ddd DD/MM/YYYY")
                .toUpperCase()
                .split(".")
                .join(" ")}
            </b>
          </p>

          <p className="text-base text-brand font-semibold line-clamp-1">
            {paidFor}
          </p>
        </div>

        {isSmall ? (
          <LoadingButton
            size="sm"
            variant="ghost"
            onClick={() =>
              window.open(
                links[lang] || Object.values(links)[0] || links.it,
                "_blank",
              )
            }
            className="flex flex-row items-center gap-2 px-0 w-6 h-6 min-w-6 min-h-6 group border-none"
          >
            <EyeIcon className="stroke-brand-secondary fill-brand-secondary w-6 h-auto" />
          </LoadingButton>
        ) : (
          <LoadingButton
            size="sm"
            onClick={() =>
              window.open(links[lang] ? links[lang] : links.it, "_blank")
            }
          >
            {t("btns.view")}
          </LoadingButton>
        )}
      </div>
    )
  );
};

export default ContractItem;
